import Addon from './Addon';

export default Addon;
